import React from 'react'
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Image
} from "antd";
import { ParagraphHeader } from "@seims/shared";

export default function PrivacyStatment() {

  const navigate = useNavigate();
  return (
    <>
      <Row justify="center" className="page-header" style={{ marginBottom: 10 }}>
        <Col xs={12} md={6} lg={4}>
          <div>
            <Image
              style={{ textAlign: 'center' }}
              src={require("../assets/privacypolicy.png")}
              preview={false}
              alt="User Guides"
              preview={false}
            />
          </div>
        </Col>
      </Row>
      <ParagraphHeader header="Privacy Policy" />
      <div className="">
        <Row justify="center" style={{ paddingBottom: 30 }} className="public-portal-page privacy-page">
          <Col lg={18} md={20} xs={24}>
            <p style={{ textAlign: "justify" }}>
              <h2 className="left-align">Privacy Statement</h2>

              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Introduction:</h3>

              <p>This privacy statement will inform you what the Department of Science, Technology and Innovation (DSTI) will do with the Personal Information it collects from you.
                It also indicates your rights as a data subject.</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Application of this Privacy Statement:</h3>

              <p>This privacy statement will apply to the DSTI and the Personal Information supplied by you. It includes any processing or further processing of the Personal Information by any Operators duly appointed by the DSTI.</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Purpose for the collection:</h3>

              <p><ul>
                <li>To register an account for you on the Public Portal application portal of the DSTI Science Engagement Information Management System (SEIMS) software application</li>
                <li>To authenticate you when using accessing the services of any of the modules on the SEIMS Public Portal software application. </li>
                <li>To assess your application for consideration to be accepted into the DSTI-NYS programme, where applicable.</li>
                <li>To assess your citizen science project for inclusion into SEIMS, where applicable.</li>
                <li>To assess your volunteer profile for inclusion into SEIMS, where applicable.</li>
                <li>To send you communication related to the status of your application or registration on the SEIMS Public Portal.</li>
                <li>To derive statistics for reporting purposes. Only anonymised and aggregated data will be used for reporting. </li>
              </ul></p>

              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Implications of withholding consent or Personal Information</h3>

              <p>The DSTI requires your Personal Information for the purposes indicated above, and your explicit consent is mandatory to process the aforementioned Personal Information;</p>
              <p>Should you elect to withhold consent for the DSTI to process your Personal Information, then the DSTI will be unable to create an account for you on the SEIMS application
                and to subsequently allow you to access the services on the SEIMS Public Portal.</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Storage, retention and destruction of information</h3>

              <p>Your Personal Information will be stored electronically in a centralised database, which, for operational reasons, will be accessible on a need to know and business basis;</p>
              <p>The DSTI undertakes to conduct regular audits regarding the safety and security of your Personal Information;</p>
              <p>Once the Personal Information is no longer required because the purpose for which it was held has expired, your Personal Information will be safely and securely archived
                for the requisite and prescribed retention periods as required by the law. On expiration of this retention period, the DSTI will permanently destroy your Personal Information
                or send it to approved external storage facilities that are PoPIA compliant, as the case may be.</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Access by others and cross border transfers</h3>

              <p>Where applicable, the DSTI will have to share your information with other organisations, i.e. NYS host organisations and the South Africa Agency for
                Science and Technology Advancement (SAASTA), that form part of the DSTI-NYS programme value chain and thus are also part of the assessment process.</p>
              <p>The DSTI may have to disclose your Personal Information to other parties, including SEIMS system development collaborators, auditors, regulatory bodies,
                and/or government officials. The DSTI will always ensure that there is a legitimate reason for such disclosure and that your Personal Information is
                handled with strict confidentiality and data security conditions;</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Right to object and complaints</h3>

              <p>You are encouraged to make immediate contact with the DSTI’s Privacy Office at any time if you are not comfortable or satisfied with the manner
                in which the DSTI is processing your Personal Information. On receipt of your objection, the DSTI will place a hold on any further processing until
                the cause of the objection has been resolved. If you are still not satisfied with such process, you have the right to lodge a complaint with the
                Information Regulator at <a href="mailto:POPIAComplaints@inforegulator.org.za">POPIAComplaints@inforegulator.org.za</a></p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Accuracy of information and responsibility</h3>

              <p>PoPIA requires that all your Personal Information and related details, as supplied are complete, accurate and up-to-date. It will be your 
                responsibility to advise the DSTI of any changes to the Personal Information, as and when these may occur.</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Access to the information by the Data Subject</h3>

              <p>You have the right at any time to ask the DSTI to provide you with the details of the Personal Information which the DSTI holds on your behalf; 
                and/or the purpose for which it has been used.</p>


              <h3 style={{ fontWeight: "bold", marginBottom: "2px" }}>Declaration and informed consent</h3>

              <p>You confirm that the Personal Information, provided to the DSTI is accurate, up-to-date, not misleading and is complete in all respects, 
                save where same may change and then in such event, you undertake to advise the DSTI of these changes.</p>
              <p>In providing the required Personal Information to the DSTI, you consent and give the DSTI permission to process and further process your 
                Personal Information as and where required and acknowledge that you understand the purposes for which the Personal Information is required 
                and for which it will be used.</p>


              <span style={{ fontWeight: "bold", marginBottom: "2px" }}>For further information, contact:</span>

              <br></br>Department of Science, Technology and Innovation (DSTI)

              <br></br> <a href="mailto:webmaster@dst.gov.za">webmaster@dst.gov.za</a><br/><br/>


              <span style={{ fontWeight: "bold", marginBottom: "2px" }}>Physical Address:</span>

              <br></br> Building 53 (CSIR South Gate Entrance)

              <br></br> Meiring Naudé Road

              <br></br>Brummeria

              <br></br>Pretoria

              <br></br>South Africa<br></br>

              <br></br>Postal Address:

              <br></br> Private Bag x 894

              <br></br> Pretoria 0001

              <br></br>South Africa

              Tel: 012 843 6300
            </p>
          </Col>
        </Row>
        <br />
        {/* <Row><Button type="primary" onClick={() => navigate("/")}>Home</Button></Row> */}
      </div>
    </>
  )
}
